import React, { useEffect, useState } from "react";
import Service from "../Service/http";
import Util from "../Service/util";
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import ChartPage from "./ChartPage";
import {FadeLoader} from "react-spinners";
import ExcelExportHelper from "./ExcelExporthelper.js";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import TimeAgo from 'react-timeago';
import { Autocomplete, TextField, Checkbox, Modal } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DropdownSelect from "./Dropdown";
import Stack from 'react-bootstrap/Stack';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FaArrowUp, FaArrowDown, FaEquals } from "react-icons/fa";
import { SELECTED_OPTIONS_KEY, IS_DETAILED_VIEW_KEY } from "./../../constants";
import "./Leaderboard.css";
import FollowUpModal from "./FollowUpModal";
import { Popover } from "react-bootstrap";
import CloseIcon from "@mui/icons-material/Close";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const detailedViewToggleDefaultValue = true;
const ReactTableFixedColumns = withFixedColumns(ReactTable);

function Main(prop) {
  let service = new Service();
  let util = new Util();
  const { batch } = useParams();
  let [ batches, SetBatches ] = useState([]);
  let [data, setData] = useState([]);
  let [color, Setcolor] = useState('');
  let [background, SetBackground] = useState("#81C784");
  let [textColor, SetTextcolor] = useState("");
  let [collegeOptions, SetCollegeOptions] = useState([]);
  let [sitesOptions, SetSitesOptions] = useState([]);
  let [critriaMap, SetCritriaMap] = useState([]);
  let [criteria, setCriteria] = useState({});
  let [isStudentOrCollege, SetIsStudentOrCollege] = useState(true);
  let [isStudent,SetisStudent] = useState(false)
  let [userId, setuserId] = useState('')
  let [loading, SetLoading] = useState(false)
  let [modalLoaderOn,setModalLoaderOn] = useState(false)
  let [id, setId] = useState(null)
  let [followupList, setFollowupList] = useState([]);
  let [CurrentUsermail,SetCurrentUserMail] = useState("")
  let [selectedName,setSleectedName] = useState("")
  let [date1, setDate1] = useState(null);
  let [date2, setDate2] = useState(null);
  const [open, setOpen] = useState(false)
  
  // check if local storage has any selected options
  let localStoredOptions = JSON.parse(localStorage.getItem(SELECTED_OPTIONS_KEY))
  let [selectedSiteOptions, setSelectedSiteOptions] = useState(localStoredOptions || [])

  // check if local storage has default view toggle value stored or not
  let localStoredDetailedViewToggleValue = JSON.parse(localStorage.getItem(IS_DETAILED_VIEW_KEY))
  
  if(localStoredDetailedViewToggleValue === null){
    localStorage.setItem(IS_DETAILED_VIEW_KEY, JSON.stringify(detailedViewToggleDefaultValue))
    localStoredDetailedViewToggleValue = detailedViewToggleDefaultValue
  }

  let [checkedDetailedView, setCheckedDetailedView] = useState(localStoredDetailedViewToggleValue)
  
  let [formulas, setFormulas] = useState();
  let [formulaColumns, setFormulaColumns] = useState();
  let [sinceretyScore, setSinceretyScore] = useState();
  let [Page, SetPage] = useState(1)
  let [FinalPage, SetFinalPage] = useState(-1);
  let [PageSize, SetPageSize] = useState(50)
  let [PageSizeOption, SetPageSizeOption] = useState([5,10,20,25,50,100])
  let [ShowFlags, SetShowFlags] = useState(false);
  let [isDelta , SetIsDelta] = useState(false);
  let [configOptions , SetConfigOptions] = useState({});
  function PaginationUpdate(){
    let Datalength = data?.length;
    if(Datalength === 0 || Datalength === null){
      SetPageSizeOption([5, 10, 15, 25, 50])
    }
    else{
    let pageOptions = []
    let defaultOptions = [5,10,20,25,50,100];
    defaultOptions.forEach(item => {
      const cur = Number(item);
      if(cur <= Datalength){
          pageOptions.push(cur)
      }
    })
    let num = 200;
    while(Number(num) <= Datalength){
      pageOptions.push(Number(num));
      num += 100;
    }
    if(pageOptions[pageOptions.length - 1] != Datalength){
      pageOptions.push(Number(Datalength));
    }
    SetPageSizeOption(pageOptions);
  }
  }

  function PopulatedFill(){
    let Datalength = data?.length;
    if(Page === FinalPage){
      let cur_size = PageSize;
      if(cur_size === 0){
        cur_size = 10;
      }
      const res = Datalength % cur_size;
      if(!isNaN(res) && res !== 0){
        SetPageSize(res);
      }
    }
  }

  useEffect(() => {
    PaginationUpdate();
  }, [data])

  useEffect(() => {
    PopulatedFill();
  }, [Page, FinalPage])

  const siteCode = {
    "CODECHEF": 'CC',
    "CODEFORCES": "CF",
    "HACKERRANK": "HR",
    "INTERVIEWBIT": "IB",
    "SPOJ": "SJ",
    "VJUDGE": "VJ",
    "MENTORPICK": "MP",
    "LEETCODE": "LC"
  }
  // *Maintain keys according to ProfileStatsModel if the column exists within it.
  const columnCode = {
    solved_count: "SC",
    solved_in_practice: "PSC",
    solved_in_contest: "CSC",
    contests_participated: "CP",
    user_rating: "RA",
    score: "S",
    highest_rating: "HR",
    star_rating: "ST",
    hackerrank_data_structures_score: "DS",
    hackerrank_algorithms_score: "A",
    sincerety_score:"SNC",
    recent_contest: "RC",
    present_to_total_ratio: "AT",
    rank: "RK"
  }

  const siteMap = {
    codechef: "CODECHEF",
    codeforces: "CODEFORCES",
    leetcode: "LEETCODE",
    mentorpick: "MENTORPICK",
    vjudge: "VJUDGE",
    spoj: "SPOJ",
    hackerrank: "HACKERRANK",
    interviewbit: "INTERVIEWBIT"
  }
  const makeFormula = (siteName, isSummary = false, isTotal = false) => {
    let formulaString = "";
    const sites = Object.keys(formulas);
    //Total Score Formula
    if (isTotal) {
      for (let site of sites) {
        formulaString += `+${siteCode[site]}`;
      }
    }
    //Summary Score Formula
    if (isSummary) {
      const columns = formulaColumns[siteName];
      const formula = formulas[siteName];
      for (let column of columns) {
        formulaString += `+${siteCode[siteName]}${columnCode[column]}*${formula[column]}`;
      }
      formulaString = formulaString.slice(1);
      formulaString = `${siteCode[siteName]}=` + formulaString;
    }
    return formulaString;
  };

  const sortDate = (a, b) => {
    const parseDate = (dateStr) => {
        if (dateStr === "NA") return -8640000000000000; // Earliest possible timestamp
        const [day, month, year] = dateStr.split("-");
        return new Date(`20${year}-${month}-${day}`).getTime(); // Converting to yyyy-mm-dd
    };

    const dateA = parseDate(a);
    const dateB = parseDate(b);
    return dateA - dateB;
  };



  let clearData = () => {
    setFollowupList([])
  }

  let getFollowup = (user_id) => {
    SetLoading(true);
    setModalLoaderOn(true)
    setId(user_id);
    service
      .get(`api/user/followup/${user_id}`)
      .then((json) => {
        console.log(json)
        if (json.result !== null) {
          setFollowupList(json.result);
          SetLoading(false);
          setModalLoaderOn(false);

        }
      })
      .catch((error) => {
        toast.error("Someting went wrong");
        console.log(error);
      }).finally(() => {
        setModalLoaderOn(false)
      })
  }

  const handlemodal = (user_id) => {
    setuserId(user_id);
    setOpen(true)
  }

  const originalWarn = console.warn;

console.warn = function (...args) {
    const arg = args && args[0];

    if (arg && arg.includes('Attempting to load version \'51\' of Google Charts')) return;

    originalWarn(...args);
};

  // In the available sites-options api, we currently get an extra string
  // It can be the last element, so need to check & remove.
  var removeStrings = ["dont_show_criteria", "show_criteria"];
  var filteredSitesOptions = Object.assign(sitesOptions)
  var i=filteredSitesOptions.length-1;
  for(var j=0; j<removeStrings.length; j++) {
    if (filteredSitesOptions[i] === removeStrings[j]) {
      filteredSitesOptions.splice(i, 1);
      break;
    }
  }

  useEffect(()=>{
    let role = util.getRole();
    SetCurrentUserMail(util.getMail())
    if( role ==="student") SetisStudent(true)

    if (role != "student" && role != "college") SetIsStudentOrCollege(false);

    async function fetchData() {
      SetLoading(true)
      try {
        const siteOptionData = await service.get("api/sites/options")
        if(siteOptionData.includes("show_criteria")) SetShowFlags(true)
        SetSitesOptions(siteOptionData);
        const deltaData = await service.get("api/delta/date")
        SetBatches(deltaData.data);
        const collegeOptionsData = await service.get("api/college/options")
        SetCollegeOptions(collegeOptionsData);
        const formulaData = await service.get("api/leaderboard/formula")
        setFormulas(formulaData.formula);
        setFormulaColumns(formulaData.scoreFields)
        setSinceretyScore(formulaData.sinceretyScore)
        let configOptions = await service.get("api/config/options")
        SetConfigOptions(configOptions)
      } catch (error) {
        console.error(error);
      } finally{
        SetLoading(false)
      }
    }

    fetchData()
  },[])

  useEffect(() => {
    let isdelta = false;

    if(batch && ((date1 && date2) || (!date1 && !date2))){
      if(!date1 || !date2) {isdelta = false; SetIsDelta(false)}
      else {isdelta = true; SetIsDelta(true)}
      SetLoading(true)
      SetCritriaMap([])
      service.get("api/all/sites/criteria/"+batch).then(json => {
        setCriteria(json?.result[1])
        let map = {}
        if(json?.result['1']){
          for (let ele of json?.result['1']) {
            if (!map[ele.platform]) map[ele.platform] = {}
            map[ele.platform][ele.criteria] = ele.mqc;
          }
        }
        SetCritriaMap(map);
        service
        .get("api/leaderboard/" + batch + "/" + isdelta + "?date1=" + date1 + "&date2=" + date2)
        .then((json) => {
          if(json.retry){
            toast.warn(json.message);
          }
          else{
            setData(json);
          }
          SetLoading(false);
        })
        .catch((error) => {
          SetLoading(false);
          console.log(error);
        });
      }).catch(error => {
        SetLoading(false);
        console.log(error);
      })
    }
  }, [batch, date1, date2]);

  function bringDateJson(date_string){
    if(date_string === "never"){
      let never_json = {Date: 0, Month: 0, Year: 0};
      return never_json;
    }

    let month_map = new Map();
    month_map.set("Jan",1);
    month_map.set("Feb",2);
    month_map.set("Mar",3);
    month_map.set("Apr",4);
    month_map.set("May",5);
    month_map.set("Jun",6);
    month_map.set("Jul",7);
    month_map.set("Aug",8);
    month_map.set("Sep",9);
    month_map.set("Oct",10);
    month_map.set("Nov",11);
    month_map.set("Dec",12);

    let month_string = date_string.slice(4,7);
    let month = month_map.get(month_string);
    let date = parseInt(date_string.slice(8,10));
    let year = parseInt(date_string.slice(11,15));
    let DateJson = {
      Date: date,
      Month: month,
      Year: year
    };
    return DateJson;
  }

  return (
    <div className="" style={{position:"relative" }}>
      {
        (util.getRole() == 'college' || util.getRole() == 'admin' || util.getRole() == 'trainer' || util.getRole() == 'mentor') ?
        <ExcelExportHelper maindata = {data} sitesOptions={sitesOptions} criteria={critriaMap} fullCriteria ={criteria} batch={batch} formulas={formulas} formulaColumns={formulaColumns}/>
          : null
      }
      <div>
        <div id="detailedViewSwitchDiv" className="form-check form-switch">
          <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" checked={checkedDetailedView} onChange={() => {
            setCheckedDetailedView(!checkedDetailedView)
            localStorage.setItem(IS_DETAILED_VIEW_KEY,  JSON.stringify(!checkedDetailedView))
            }}/>
          <label className="form-check-label" for="flexSwitchCheckDefault">Detailed View</label>
        </div>
        <div style={{ textAlign:"center"}}>
          <h3 className="text-primary mt-3" >{batch}</h3>
        </div>
        <div id="siteOptionsAndDeltaDateRangeParentDiv">
          <div id="siteOptionsDropdownDiv">
            <DropdownSelect options={filteredSitesOptions} setSelectedOptions={setSelectedSiteOptions}/>
          </div>
          <div id="deltaDateRangeDiv">
            {
              (util.getRole() == 'college' || util.getRole() == 'admin' || util.getRole() == 'trainer' || util.getRole() == 'mentor') ?
              <>
                <Autocomplete disablePortal disableCloseOnSelect id="checkboxes-tags-demoo"
                  renderOption={(props, option, { selected }) => (
                  <li {...props}> <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8  }} checked={selected}/>
                    {option}
                  </li>)}
                  options={ batches}
                  sx={{ width: 300 , display: 'inline-block', marginRight: 2, verticalAlign : "middle"}}
                  onChange={(event, newValue) => {setDate1(newValue); }}
                  renderInput={(params) => <TextField {...params} label="Delta From" />}
                />
                <Autocomplete disablePortal disableCloseOnSelect id="checkboxes-tags-demoo"
                  renderOption={(props, option, { selected }) => (
                  <li {...props}> <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8  }} checked={selected}/>
                    {option}
                  </li>)}
                  options={ batches}
                  sx={{ width: 300 , display: 'inline-block', marginRight: 2, verticalAlign : "middle"}}
                  onChange={(event, newValue) => {setDate2(newValue); }}
                  renderInput={(params) => <TextField {...params} label="Delta To" />}
                />
              </>
              : null
            }
          </div>
        </div>
      </div>

      {loading?<div style={{ marginTop: "10vh", marginRight:"10vh",textAlign:"center"}}><FadeLoader  margin={5} color="green" /></div>:
      <div className="">

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        className="d-flex justify-content-center align-items-center model-sm"
      >
        <div
          className="bg-white p-2 mt-3 rounded"
          style={{ width: "80%", maxWidth: "100%" }}
        >
          <div className="d-flex justify-content-end mb-2">
            <button
              onClick={() => setOpen(false)}
              className="btn btn-light"
              style={{
                padding: "0.5rem",
                marginTo:'10px',
                borderRadius: "50%",
                border: "none",
                cursor: "pointer",
              }}
            >
              <CloseIcon />
            </button>
          </div>

          <h3 className="text-center ">User Activity on Coding Platforms</h3>
          <hr/>
          <ChartPage user_id={userId} />
        </div>
      </Modal>

      <FollowUpModal 
        followupList={followupList} 
        isStudentOrCollege={isStudentOrCollege} 
        selectedName={selectedName} 
        setFollowupList={setFollowupList} 
        userId={id} 
        modalLoaderOn={modalLoaderOn}
      />

      <ReactTableFixedColumns
        data={data}
        // The height is being set to 110vh as this will force overflow in y-axis and the header is fixed in one place
        style={{textAlign: "center", fontWeight: "bolder",fontSize:"16px", height: (data.length < 10) ? "auto" : "110vh"}}
        pageSize = {PageSize}
        pageSizeOptions = {PageSizeOption}
        minRows = {5}
        loadingText = {'Loading...'}
        onPageSizeChange = {(pageSize, pageIndex) =>{
          SetPage(pageIndex)
          SetPageSize(pageSize)
        }}
        onPageChange = {(num) => {
          SetPage(num);
        }}
        renderTotalPagesCount = {(num) => {
          if(!isFinite(num) || isNaN(num)){
            num = 1;
          }
          SetFinalPage(num);
          if(num === 0){
            return 1;
          }
          return num;
        }}
        columns={[
          {
            Header: "USER DETAILS",
            fixed: "left",
            columns: [
              {
                Header: "Rank",
                id: "row",
                accessor: "no",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (rowInfo?.original?.my) ? 'white' : 'white',
                      background: rowInfo?.original?.my ? background : "#0F9ADC",
                    },
                  };
                },
                width: 50,
              },
              {
                Header: "Name",
                accessor: "name",
                Cell: e => (isStudentOrCollege == false) ? <a
                  className="text-secondary"
                  target="_blank" href={"/coding/profile/" + e.original.user_id}> {e.value} </a> : <span>  {e.value}</span>,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (rowInfo?.original?.my) ? color : textColor,
                      background: rowInfo?.original?.my ? background : "#B2EBF2",
                    },
                  };
                },
                width: 200,
              },
              {
                Header: "Roll No",
                accessor: "roll_number",
                Cell: e => (isStudentOrCollege == false) ? <a
                  className="text-secondary"
                  data-bs-toggle="modal" data-bs-target="#graphModal"
                  href="#"
                  onClick={() => handlemodal(e.original.user_id)}
                > {e.value} </a> : <span>  {e.value}</span>,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (rowInfo?.original?.my) ? color : textColor,
                      background: rowInfo?.original?.my ? background : "#B2EBF2",
                    },
                  };
                },
                width: 130,
              },
              /*
               className="text-primary"
                                data-bs-toggle="modal" data-bs-target="#followupModal"
                                href="#"
                                onClick={() => {
                                  getFollowup(users[ind]._id)
                                  setratingPoints(0);
                                  setratingString("FollowUp Rating")
              */
              {
                Header: ()=>(<div><div>Sincerity Score</div><div style={{fontSize: '12px'}}>{columnCode?.sincerety_score}</div></div>),
                accessor: "sincerity_score",
                Cell: e => (isStudent == false||(e.original.email===CurrentUsermail)) ? <div
                  className="text-secondary"
                  data-bs-toggle="modal" data-bs-target="#followupModal"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    SetLoading(true)
                    clearData();
                    getFollowup(e.original.user_id)
                    setSleectedName(e.original.name)
                    SetLoading(false)
                  }}
                > {e.value} </div> : <span>  {e.value}</span>,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (rowInfo?.original?.my) ? textColor : textColor,
                      background: rowInfo?.original?.sincerity_score>0?"#66cc66":rowInfo?.original?.sincerity_score<0?"#ff6666":rowInfo?.original?.negativeComment?"#ffb833":"#B2EBF2",
                    },
                  };
                },
                width: 130 ,
              },
              //href={"/coding/graph/"+ e.original.user_id}
              // target="_blank"
            ],
          },
          {
            Header: "CODECHEF",
            columns: [
              {
                show: sitesOptions.includes("CODECHEF") && selectedSiteOptions.includes("CODECHEF") && checkedDetailedView,
                Header: ()=>(<div><div>Contest Solved Count</div><div style={{fontSize: '12px'}}>{`${siteCode?.CODECHEF}${columnCode?.solved_in_contest}`}</div></div>),
                accessor: "codechef_solved_in_contest",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.CODECHEF?.solved_count) && rowInfo?.original?.codechef_solved_count < critriaMap.CODECHEF.solved_count) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#E0F2F1",
                    },
                  };
                },
                width: 170,
              },
              {
                show: sitesOptions.includes("CODECHEF") && selectedSiteOptions.includes("CODECHEF") && checkedDetailedView,
                Header: ()=>(<div><div style={{display: 'flex', justifyContent: 'center'}}><Stack direction="horizontal" gap={1}>Practice Solved Count
                <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip>This attribute will only display count of publicly avalible and solved problems from codehef.</Tooltip>}
                >
                <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className=""><path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" /></svg>
              </OverlayTrigger></Stack>
                </div><div style={{fontSize: '12px'}}>{`${siteCode?.CODECHEF}${columnCode?.solved_in_practice}`}</div></div>),
                accessor: "codechef_solved_in_practice",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.CODECHEF?.solved_count) && rowInfo?.original?.codechef_solved_count < critriaMap.CODECHEF.solved_count) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#E0F2F1",
                    },
                  };
                },
                width: 200,
              },
              {
                show: sitesOptions.includes("CODECHEF") && selectedSiteOptions.includes("CODECHEF") && checkedDetailedView,
                Header: ()=>(<div><div>Total Solved Count</div><div style={{fontSize: '12px'}}>{`${siteCode?.CODECHEF}${columnCode?.solved_count}`}</div></div>),
                accessor: "codechef_solved_count",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.CODECHEF?.solved_count) && rowInfo?.original?.codechef_solved_count < critriaMap.CODECHEF.solved_count) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#E0F2F1",
                    },
                  };
                },
                width: 170,
              },
              {
                show: sitesOptions.includes("CODECHEF") && selectedSiteOptions.includes("CODECHEF") && checkedDetailedView,
                Header: ()=>(<div><div style={{display: 'flex', justifyContent: 'center'}}><Stack direction="horizontal" gap={1}>Contest Participated
                <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip>Only Rated contests are being considered.</Tooltip>}
                >
                <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className=""><path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" /></svg>
              </OverlayTrigger></Stack></div><div style={{fontSize: '12px'}}>{`${siteCode?.CODECHEF}${columnCode?.contests_participated}`}</div></div>),
                accessor: "codechef_contest_participated",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.CODECHEF?.contests_participated) && rowInfo?.original?.codechef_contest_participated < critriaMap.CODECHEF.contests_participated) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#E0F2F1",
                    },
                  };
                },
                width: 200,
              },
              {
                show: sitesOptions.includes("CODECHEF") && selectedSiteOptions.includes("CODECHEF") && checkedDetailedView,
                Header: ()=>(<div><div>Recent Contest</div><div style={{fontSize: '12px'}}>{`${siteCode?.CODECHEF}${columnCode?.recent_contest}`}</div></div>),
                accessor: "codechef_most_recent_contest_participated",
                Cell: e => <span title={e.original.codechef_most_recent_contest_name_participated}>{ e.value}</span>,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (critriaMap?.CODECHEF && rowInfo?.original?.codechef_most_recent_contest_participated == "NA") ? "red" : "green",
                      background: rowInfo?.original?.my ? background : "#E0F2F1",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("CODECHEF") && selectedSiteOptions.includes("CODECHEF") && checkedDetailedView,
                Header: ()=>(<div><div>User Rating</div><div style={{fontSize: '12px'}}>{`${siteCode?.CODECHEF}${columnCode?.user_rating}`}</div></div>),
                accessor: "codechef_user_rating",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (((critriaMap?.CODECHEF?.user_rating) && rowInfo?.original?.codechef_user_rating < critriaMap.CODECHEF.user_rating)) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#E0F2F1",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("CODECHEF") && selectedSiteOptions.includes("CODECHEF") && checkedDetailedView,
                Header: ()=>(<div><div>Highest Rating</div><div style={{fontSize: '12px'}}>{`${siteCode?.CODECHEF}${columnCode?.highest_rating}`}</div></div>),
                accessor: "codechef_highest_rating",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.CODECHEF?.highest_rating) && rowInfo?.original?.codechef_highest_rating < critriaMap.CODECHEF.highest_rating) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#E0F2F1",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("CODECHEF") && selectedSiteOptions.includes("CODECHEF") && checkedDetailedView,
                Header: ()=>(<div><div>Stars</div><div style={{fontSize: '12px'}}>{`${siteCode?.CODECHEF}${columnCode?.star_rating}`}</div></div>),
                accessor: "codechef_star_rating",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.CODECHEF?.star_rating) && rowInfo?.original?.codechef_star_rating < critriaMap.CODECHEF.star_rating) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#E0F2F1",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("CODECHEF") && selectedSiteOptions.includes("CODECHEF"),
                Header: ()=>(<div><div>CodeChef Score</div><div style={{fontSize: '12px'}}>{formulas && formulaColumns && makeFormula(siteMap?.codechef, true)}</div></div>),
                Cell: e => (e.original.codechef_site_user_blocked) ? "BLOCKED" : e.value,
                accessor: "codechef_summary_score",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (rowInfo?.original?.codechef_site_user_blocked) ? 'red' : ((critriaMap?.CODECHEF?.summary_score) && rowInfo?.original?.codechef_summary_score < critriaMap.CODECHEF.summary_score) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#E0F2F1",
                    },
                  };
                },
                width: 200
              },
              {
                show: sitesOptions.includes("CODECHEF") && selectedSiteOptions.includes("CODECHEF") && checkedDetailedView,
                Header: ()=>(<div>Last Activity</div>),
                accessor: "codechef_last_active",
                sortMethod: sortDate,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: 'green',
                      background: rowInfo?.original?.my ? background : "#E0F2F1",
                    },
                  };
                },
                width: 170,
              },
            ],
          },
          {
            Header: "CODEFORCES",
            columns: [
              {
                show: sitesOptions.includes("CODEFORCES") && selectedSiteOptions.includes("CODEFORCES") && checkedDetailedView,
                Header: ()=>(<div><div>Contest Solved Count</div><div style={{fontSize: '12px'}}>{`${siteCode?.CODEFORCES}${columnCode?.solved_in_contest}`}</div></div>),
                accessor: "codeforces_solved_in_contest",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.CODEFORCES?.solved_count) && rowInfo?.original?.codeforces_solved_count < critriaMap.CODEFORCES.solved_count) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#e6ffff",
                    },
                  };
                },
                width: 170,
              },
              {
                show: sitesOptions.includes("CODEFORCES") && selectedSiteOptions.includes("CODEFORCES") && checkedDetailedView,
                Header: ()=>(<div><div>Practice Solved Count</div><div style={{fontSize: '12px'}}>{`${siteCode?.CODEFORCES}${columnCode?.solved_in_practice}`}</div></div>),
                accessor: "codeforces_solved_in_practice",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.CODEFORCES?.solved_count) && rowInfo?.original?.codeforces_solved_count < critriaMap.CODEFORCES.solved_count) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#e6ffff",
                    },
                  };
                },
                width: 170,
              },
              {
                show: sitesOptions.includes("CODEFORCES") && selectedSiteOptions.includes("CODEFORCES") && checkedDetailedView,
                Header: ()=>(<div><div>Total Solved Count</div><div style={{fontSize: '12px'}}>{`${siteCode?.CODEFORCES}${columnCode?.solved_count}`}</div></div>),
                accessor: "codeforces_solved_count",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.CODEFORCES?.solved_count) && rowInfo?.original?.codeforces_solved_count < critriaMap.CODEFORCES.solved_count) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#e6ffff",
                    },
                  };
                },
                width: 170,
              },
              {
                show: sitesOptions.includes("CODEFORCES") && selectedSiteOptions.includes("CODEFORCES") && checkedDetailedView,
                Header: ()=>(<div><div style={{display: 'flex', justifyContent: 'center'}}><Stack direction="horizontal" gap={1}>Contests Participated
                  <OverlayTrigger
                  placement="bottom"
                  delay={{ show: 250, hide: 400 }}
                  overlay={<Tooltip>The Contest data is updated after your rating changes on Codeforces. It is usually updated 24 hours after the contest</Tooltip>}
                  >
                         <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className=""><path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" /></svg>
                </OverlayTrigger></Stack> </div><div style={{fontSize: '12px'}}>{`${siteCode?.CODEFORCES}${columnCode?.contests_participated}`}</div></div>),
                accessor: "codeforces_contests_participated",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.CODEFORCES?.contests_participated) && rowInfo?.original?.codeforces_contests_participated < critriaMap.CODEFORCES.contests_participated) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#e6ffff",
                    },
                  };
                },
                width: 200,
              },
              {
                show: sitesOptions.includes("CODEFORCES") && selectedSiteOptions.includes("CODEFORCES") && checkedDetailedView,
                Header: ()=>(<div><div>Recent Contest</div><div style={{fontSize: '12px'}}>{`${siteCode?.CODEFORCES}${columnCode?.recent_contest}`}</div></div>),
                accessor: "codeforces_most_recent_contest_participated",
                Cell: e => <span title={e.original.codeforces_most_recent_contest_name_participated}>{ e.value}</span>,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (critriaMap?.CODEFORCES && rowInfo?.original?.codeforces_most_recent_contest_participated == "NA") ? "red" : "green",
                      background: rowInfo?.original?.my ? background : "#e6ffff",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("CODEFORCES") && selectedSiteOptions.includes("CODEFORCES") && checkedDetailedView,
                Header: ()=>(<div><div>User Rating</div><div style={{fontSize: '12px'}}>{`${siteCode?.CODEFORCES}${columnCode?.user_rating}`}</div></div>),
                accessor: "codeforces_user_rating",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.CODEFORCES?.user_rating) && rowInfo?.original?.codeforces_user_rating < critriaMap.CODEFORCES.user_rating) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#e6ffff",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("CODEFORCES") && selectedSiteOptions.includes("CODEFORCES") && checkedDetailedView,
                Header: ()=>(<div><div>Highest Rating</div><div style={{fontSize: '12px'}}>{`${siteCode?.CODEFORCES}${columnCode?.highest_rating}`}</div></div>),
                accessor: "codeforces_highest_rating",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.CODEFORCES?.highest_rating) && rowInfo?.original?.codeforces_highest_rating < critriaMap.CODEFORCES.highest_rating) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#e6ffff",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("CODEFORCES") && selectedSiteOptions.includes("CODEFORCES"),
                Header: ()=>(<div><div>CodeForces Score</div><div style={{fontSize: '12px'}}>{formulas && formulaColumns && makeFormula(siteMap?.codeforces, true)}</div></div>),
                accessor: "codeforces_summary_score",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.CODEFORCES?.summary_score) && rowInfo?.original?.codeforces_summary_score < critriaMap.CODEFORCES.summary_score) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#e6ffff",
                    },
                  };
                },
                width: 200,
              },
              {
                show: sitesOptions.includes("CODEFORCES") && selectedSiteOptions.includes("CODEFORCES") && checkedDetailedView,
                Header: ()=>(<div>Last Activity</div>),
                accessor: "codeforces_last_active",
                sortMethod: sortDate,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: 'green',
                      background: rowInfo?.original?.my ? background : "#e6ffff",
                    },
                  };
                },
                width: 170,
              },
            ],
          },
          {
            Header: "HACKERRANK",
            columns: [
              {
                show: sitesOptions.includes("HACKERRANK") && selectedSiteOptions.includes("HACKERRANK") && checkedDetailedView,
                Header: ()=>(<div><div>Data Structure</div><div style={{fontSize: '12px'}}>{`${siteCode?.HACKERRANK}${columnCode?.hackerrank_data_structures_score}`}</div></div>),
                accessor: "hackerrank_data_structures_score",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.HACKERRANK?.hackerrank_data_structures_score) && rowInfo?.original?.hackerrank_data_structures_score < critriaMap.HACKERRANK.hackerrank_data_structures_score) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#EFEBE9",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("HACKERRANK") && selectedSiteOptions.includes("HACKERRANK") && checkedDetailedView,
                Header: ()=>(<div><div>Algorithms</div><div style={{fontSize: '12px'}}>{`${siteCode?.HACKERRANK}${columnCode?.hackerrank_algorithms_score}`}</div></div>),
                accessor: "hackerrank_algorithms_score",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.HACKERRANK?.hackerrank_algorithms_score) && rowInfo?.original?.hackerrank_algorithms_score < critriaMap.HACKERRANK.hackerrank_algorithms_score) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#EFEBE9",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("HACKERRANK") && selectedSiteOptions.includes("HACKERRANK") && checkedDetailedView,
                Header: ()=>(<div><div>Badge Stars</div><div style={{fontSize: '12px'}}>{`${siteCode?.HACKERRANK}${columnCode?.star_rating}`}</div></div>),
                accessor: "hackerrank_star_rating",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.HACKERRANK?.star_rating) && rowInfo?.original?.hackerrank_star_rating < critriaMap.HACKERRANK.star_rating) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#EFEBE9",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("HACKERRANK") && selectedSiteOptions.includes("HACKERRANK"),
                Header: ()=>(<div><div>HackerRank Score</div><div style={{fontSize: '12px'}}>{formulas && formulaColumns && makeFormula(siteMap?.hackerrank, true)}</div></div>),
                accessor: "hackerrank_summary_score",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.HACKERRANK?.summary_score) && rowInfo?.original?.hackerrank_summary_score < critriaMap.HACKERRANK.summary_score) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#EFEBE9",
                    },
                  };
                },
                width: 200,
              },
            ],
          },
          {
            show: sitesOptions.includes("LEETCODE"),
            Header: "LEETCODE",
            columns: [
              {
                show: sitesOptions.includes("LEETCODE") && selectedSiteOptions.includes("LEETCODE") && checkedDetailedView,
                Header: ()=>(<div><div>Contest Solved Count</div><div style={{fontSize: '12px'}}>{`${siteCode?.LEETCODE}${columnCode?.solved_in_contest}`}</div></div>),
                accessor: "leetcode_solved_in_contest",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.LEETCODE?.solved_count) && rowInfo?.original?.leetcode_solved_count < critriaMap.LEETCODE.solsolved_in_contest) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#E0F2F1",
                    },
                  };
                },
                width: 170,
              },
              {
                show: sitesOptions.includes("LEETCODE") && selectedSiteOptions.includes("LEETCODE") && checkedDetailedView,
                Header: ()=>(<div><div>Practice Solved Count</div><div style={{fontSize: '12px'}}>{`${siteCode?.LEETCODE}${columnCode?.solved_in_practice}`}</div></div>),
                accessor: "leetcode_solved_in_practice",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.LEETCODE?.solved_count) && rowInfo?.original?.leetcode_solved_count < critriaMap.LEETCODE.solved_count) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#E0F2F1",
                    },
                  };
                },
                width: 170,
              },
              {
                show: sitesOptions.includes("LEETCODE") && selectedSiteOptions.includes("LEETCODE") && checkedDetailedView,
                Header: ()=>(<div><div>Total Solved Count</div><div style={{fontSize: '12px'}}>{`${siteCode?.LEETCODE}${columnCode?.solved_count}`}</div></div>),
                accessor: "leetcode_solved_count",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.LEETCODE?.solved_count) && rowInfo?.original?.leetcode_solved_count < critriaMap.LEETCODE.solved_count) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#E0F2F1",
                    },
                  };
                },
                width: 170,
              },
              {
                show: sitesOptions.includes("LEETCODE") && selectedSiteOptions.includes("LEETCODE") && checkedDetailedView,
                Header: ()=>(<div><div style={{display: 'flex', justifyContent: 'center'}}>
                  <Stack direction="horizontal" gap={1}>Contests Participated
                  <OverlayTrigger
                  placement="bottom"
                  delay={{ show: 250, hide: 400 }}
                  overlay={<Tooltip>The Contests data is updated after your rating changes on Leetcode. It is usually updated a week after the contest</Tooltip>}
                  >
                         <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className=""><path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" /></svg>
                </OverlayTrigger></Stack>
       </div><div style={{fontSize: '12px'}}>{`${siteCode?.LEETCODE}${columnCode?.contests_participated}`}</div></div>),
                accessor: "leetcode_contests_participated",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.LEETCODE?.contests_participated) && rowInfo?.original?.leetcode_contests_participated < critriaMap.LEETCODE.contests_participated) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#E0F2F1",
                    },
                  };
                },
                width: 200,
              },{
                show: sitesOptions.includes("LEETCODE") && selectedSiteOptions.includes("LEETCODE") && checkedDetailedView,
                Header: ()=>(<div><div>Recent Contest</div><div style={{fontSize: '12px'}}>{`${siteCode?.LEETCODE}${columnCode?.recent_contest}`}</div></div>),
                accessor: "leetcode_most_recent_contest_participated",
                Cell: e => <span title={e.original.leetcode_most_recent_contest_name_participated}>{ e.value}</span>,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (critriaMap?.LEETCODE && rowInfo?.original?.leetcode_most_recent_contest_participated == "NA") ? "red" : "green",
                      background: rowInfo?.original?.my ? background : "#E0F2F1",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("LEETCODE") && selectedSiteOptions.includes("LEETCODE") && checkedDetailedView,
                Header: ()=>(<div><div>Rating</div><div style={{fontSize: '12px'}}>{`${siteCode?.LEETCODE}${columnCode?.user_rating}`}</div></div>),
                accessor: "leetcode_user_rating",
                Cell: e => <span> {Math.round(e.value)} </span>,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.LEETCODE?.user_rating) && rowInfo?.original?.leetcode_user_rating < critriaMap.LEETCODE.user_rating) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#E0F2F1",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("LEETCODE") && selectedSiteOptions.includes("LEETCODE"),
                Header: ()=>(<div><div>LeetCode Score</div><div style={{fontSize: '12px'}}>{formulas && formulaColumns && makeFormula(siteMap?.leetcode, true)}</div></div>),
                accessor: "leetcode_summary_score",
                Cell: e => <span> {Math.round(e.value)} </span>,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.LEETCODE?.summary_score) && rowInfo?.original?.leetcode_summary_score < critriaMap.LEETCODE.summary_score) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#E0F2F1",
                    },
                  };
                },
                width: 200,
              },
              {
                show: sitesOptions.includes("LEETCODE") && selectedSiteOptions.includes("LEETCODE") && checkedDetailedView,
                Header: ()=>(<div>Last Activity</div>),
                accessor: "leetcode_last_active",
                sortMethod: sortDate,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: 'green',
                      background: rowInfo?.original?.my ? background : "#E0F2F1",
                    },
                  };
                },
                width: 170,
              },
            ],
          },
          {
            Header: "INTERVIEWBIT",
            columns: [
              {
                show: sitesOptions.includes("INTERVIEWBIT") && selectedSiteOptions.includes("INTERVIEWBIT") && checkedDetailedView,
                Header: ()=>(<div><div>Score</div><div style={{fontSize: '12px'}}>{`${siteCode?.INTERVIEWBIT}${columnCode?.score}`}</div></div>),
                accessor: "interviewbit_score",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.INTERVIEWBIT?.score) && rowInfo?.original?.interviewbit_score < critriaMap.INTERVIEWBIT.score) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#E8F5E9",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("INTERVIEWBIT") && selectedSiteOptions.includes("INTERVIEWBIT") && checkedDetailedView,
                Header: ()=>(<div><div>Rank</div><div style={{fontSize: '12px'}}>{`${siteCode?.INTERVIEWBIT}${columnCode?.rank}`}</div></div>),
                accessor: "interviewbit_rank",
                Cell: e => <span> {e.value ? e.value : "NA"} </span>,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (((critriaMap?.INTERVIEWBIT?.rank) && rowInfo?.original?.interviewbit_rank > critriaMap.INTERVIEWBIT.rank) ) ? 'red' : 'green',
                      // color: (((critriaMap?.INTERVIEWBIT?.rank) && rowInfo?.original?.interviewbit_rank > critriaMap.INTERVIEWBIT.rank) || (critriaMap?.INTERVIEWBIT && rowInfo?.original?.interviewbit_rank == 0)) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#E8F5E9",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("INTERVIEWBIT") && selectedSiteOptions.includes("INTERVIEWBIT"),
                Header: ()=>(<div><div>InterviewBit Score</div><div style={{fontSize: '12px'}}>{formulas && formulaColumns && makeFormula(siteMap?.interviewbit, true)}</div></div>),
                accessor: "interviewbit_summary_score",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (((critriaMap?.INTERVIEWBIT?.summary_score) && rowInfo?.original?.interviewbit_summary_score > critriaMap.INTERVIEWBIT.summary_score) ) ? 'red' : 'green',
                      // color: (((critriaMap?.INTERVIEWBIT?.rank) && rowInfo?.original?.interviewbit_rank > critriaMap.INTERVIEWBIT.rank) || (critriaMap?.INTERVIEWBIT && rowInfo?.original?.interviewbit_rank == 0)) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#E8F5E9",
                    },
                  };
                },
                width: 200,
              },
            ],
          },
          {
            show: sitesOptions.includes("SPOJ"),
            Header: "SPOJ",
            columns: [
              {
                show: sitesOptions.includes("SPOJ") && selectedSiteOptions.includes("SPOJ") && checkedDetailedView,
                Header: ()=>(<div><div>Solved Count</div><div style={{fontSize: '12px'}}>{`${siteCode?.SPOJ}${columnCode?.solved_count}`}</div></div>),
                accessor: "spoj_solved_count",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.SPOJ?.solved_count) && rowInfo?.original?.spoj_solved_count < critriaMap.SPOJ.solved_count) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#FFF8E1",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("SPOJ") && selectedSiteOptions.includes("SPOJ") && checkedDetailedView,
                Header: ()=>(<div><div>Rank</div><div style={{fontSize: '12px'}}>{`${siteCode?.SPOJ}${columnCode?.rank}`}</div></div>),
                accessor: "spoj_rank",
                Cell: e => <span> {e.value ? e.value : "NA"} </span>,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (((critriaMap?.SPOJ?.rank) && rowInfo?.original?.spoj_rank > critriaMap.SPOJ.rank)) ? 'red' : 'green',
                      // color: (((critriaMap?.SPOJ?.rank) && rowInfo?.original?.spoj_rank > critriaMap.SPOJ.rank) || (critriaMap?.SPOJ && rowInfo?.original?.spoj_rank == 0)) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#FFF8E1",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("SPOJ") && selectedSiteOptions.includes("SPOJ"),
                Header: ()=>(<div><div>Spoj Score</div><div style={{fontSize: '12px'}}>{formulas && formulaColumns && makeFormula(siteMap?.spoj, true)}</div></div>),
                accessor: "spoj_summary_score",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (((critriaMap?.SPOJ?.summary_score) && rowInfo?.original?.spoj_summary_score > critriaMap.SPOJ.summary_score)) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#FFF8E1",
                    },
                  };
                },
                width: 140,
              },
            ],
          },
          {
            Header: "VJUDGE",
            columns: [
              {
                show: sitesOptions.includes("VJUDGE") && selectedSiteOptions.includes("VJUDGE") && checkedDetailedView,
                Header: ()=>(<div><div>Solved Count</div><div style={{fontSize: '12px'}}>{`${siteCode?.VJUDGE}${columnCode?.solved_count}`}</div></div>),
                accessor: "vjudge_solved_count",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.VJUDGE?.solved_count) && rowInfo?.original?.vjudge_solved_count < critriaMap.VJUDGE.solved_count) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#FBE9E7",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("VJUDGE") && selectedSiteOptions.includes("VJUDGE"),
                Header: ()=>(<div><div>Vjudge Score</div><div style={{fontSize: '12px'}}>{formulas && formulaColumns && makeFormula(siteMap?.vjudge, true)}</div></div>),
                accessor: "vjudge_summary_score",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.VJUDGE?.summary_score) && rowInfo?.original?.vjudge_summary_score < critriaMap.VJUDGE.summary_score) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#FBE9E7",
                    },
                  };
                },
                width: 140,
              }
            ],
          },
          {
            Header: "MENTORPICK",
            columns: [
              {
                show: sitesOptions.includes("MENTORPICK") && selectedSiteOptions.includes("MENTORPICK") && checkedDetailedView,
                Header: ()=>(<div><div>Solved Count</div><div style={{fontSize: '12px'}}>{`${siteCode?.MENTORPICK}${columnCode?.solved_count}`}</div></div>),
                accessor: "mentorpick_solved_count",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.MENTORPICK?.solved_count) && rowInfo?.original?.mentorpick_solved_count < critriaMap.MENTORPICK.solved_count) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#fff5ee",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("MENTORPICK") && selectedSiteOptions.includes("MENTORPICK") && checkedDetailedView,
                Header: ()=>(<div><div>Contest Participated</div><div style={{fontSize: '12px'}}>{`${siteCode?.MENTORPICK}${columnCode?.contests_participated}`}</div></div>),
                accessor: "mentorpick_contests_participated",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: ((critriaMap?.MENTORPICK?.contests_participated) && rowInfo?.original?.mentorpick_contests_participated < critriaMap.MENTORPICK.contests_participated) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#fff5ee",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("MENTORPICK") && selectedSiteOptions.includes("MENTORPICK") && checkedDetailedView,
                Header: ()=>(<div><div>Recent Contest Participated</div><div style={{fontSize: '12px'}}>{`${siteCode?.MENTORPICK}${columnCode?.recent_contest}`}</div></div>),
                accessor: "recent_contest_participated",
                Cell: e => <span title={e.original.mentorpick_most_recent_contest_name_participated}>{ e.value}</span>,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background: rowInfo?.original?.my ? background : "#fff5ee",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("MENTORPICK") && selectedSiteOptions.includes("MENTORPICK"),
                Header: ()=>(<div>User Rating</div>),
                accessor: "mentorpick_user_rating",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (((critriaMap?.MENTORPICK?.user_rating) && rowInfo?.original?.mentorpick_user_rating < critriaMap.MENTORPICK.user_rating)) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#fff5ee",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("MENTORPICK") && selectedSiteOptions.includes("MENTORPICK"),
                Header: ()=>(<div><div>Mentorpick Score</div><div style={{fontSize: '12px'}}>{formulas && formulaColumns && makeFormula(siteMap?.mentorpick, true)}</div></div>),
                accessor: "mentorpick_summary_score",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background: rowInfo?.original?.my ? background : "#fff5ee",
                    },
                  };
                },
                width: 140,
              },
              {
                show: sitesOptions.includes("MENTORPICK") && selectedSiteOptions.includes("MENTORPICK") && checkedDetailedView,
                Header: ()=>(<div>Last Activity</div>),
                accessor: "mentorpick_last_active",
                sortMethod: sortDate,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: 'green',
                      background: rowInfo?.original?.my ? background : "#fff5ee",
                    },
                  };
                },
                width: 140,
              },
            ],
          },
          {
            Header: "SCORABLE",
            columns: [
              {
                show: sitesOptions.includes("MENTORPICK") && selectedSiteOptions.includes("MENTORPICK") && checkedDetailedView,
                Header: ()=>(<div><div style={{display: 'flex', justifyContent: 'center'}}>
                  <Stack direction="horizontal" gap={1}>Solved Count
                    <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip>Solved count of problems added as ProblemSet in CPTRACKER.</Tooltip>}
                        >
                        <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className=""><path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" /></svg>
                    </OverlayTrigger>
                  </Stack>
                </div></div>),
                accessor: "scorable_solved_count",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {

                      // scorable_solved_count field is available in all sites criteria. Using mentorpick from all
                      color: ((critriaMap?.MENTORPICK?.scorable_solved_count) && rowInfo?.original?.scorable_solved_count < critriaMap.MENTORPICK.scorable_solved_count) ? 'red' : 'green',
                      background: rowInfo?.original?.my ? background : "#fff5ee",
                    },
                  };
                },
                width: 140,
              },
            ],
          },
          {
            Header: "USER DATA",
            columns: [
          {
            show: selectedSiteOptions.includes("User: School GPA/Percentage") && configOptions.show_school_gpa == "true",
            Header: "School GPA/Percentage",
            accessor: "school_gpa",
            getProps: (state, rowInfo, column) => {
              return {
                style: {
                  color: (rowInfo?.original?.my) ? color : textColor,
                  background: rowInfo?.original?.my ? background : "#B2EBF2",
                },
              };
            },
            width : 120
          },
          {
            show: selectedSiteOptions.includes("User: Inter GPA/Percentage") && configOptions.show_inter_gpa == "true",
            Header: "Inter GPA/Percentage",
            accessor: "inter_gpa",
            getProps: (state, rowInfo, column) => {
              return {
                style: {
                  color: (rowInfo?.original?.my) ? color : textColor,
                  background: rowInfo?.original?.my ? background : "#B2EBF2",
                },
              };
            },
            width : 100
          }, 
          {
            show: selectedSiteOptions.includes("Score: VQR Score") && configOptions.show_vqr == "true",
            Header: "VQR Score",
            accessor: "vqr_score",
            getProps: (state, rowInfo, column) => {
              return {
                style: {
                  color: (rowInfo?.original?.my) ? color : textColor,
                  background: rowInfo?.original?.my ? background : "#B2EBF2",
                },
              };
            },
            width : 100
          },
          {
            show: selectedSiteOptions.includes("Info: FollowUp"),
            Header: "FollowUp",
            accessor: "followup",
            Cell: e=>(e.original.followup!=="never"? <TimeAgo date={new Date(e.original.followup)} />:"never"),
            getProps: (state, rowInfo, column) => {
              return {
                style: {
                  color: (rowInfo?.original?.my) ? color : textColor,
                  background: rowInfo?.original?.my ? background : "#B2EBF2",
                },
              };
            },
            width: 140,
            sortMethod: (a, b) => {
              let x = bringDateJson(a);
              let y = bringDateJson(b);
              if(x.Year < y.Year) return 1;
              else if(x.Year > y.Year) return -1;
              else {
                if(x.Month < y.Month) return 1;
                else if(x.Month > y.Month) return -1;
                else {
                  if(x.Date < y.Date) return 1;
                  else if(x.Date > y.Date) return -1;
                  else {
                    return 0;
                  }
                }
              }
            },
          },
          {
            show: selectedSiteOptions.includes("Info: Attendance"),
            Header: ()=>(<div><div>Attendance</div><div style={{fontSize: '12px'}}>{columnCode?.present_to_total_ratio}</div></div>),
            accessor: "present_to_total_ratio",
            getProps: (state, rowInfo, column) => {
              return {
                style: {
                  color: (rowInfo?.original?.my) ? textColor : textColor,
                  background: "#B2EBF2",
                },
              };
            },
            width: 130 ,
          }, 
          ]
        },
          {
            Header: "CRAWL TIME",
            columns: [
              {
                show: selectedSiteOptions.includes("Info: CrawlTime"),
                Header: "Last Updated",
                accessor: "user_last_crawled_at",
                Cell: (e) => (
                  <span >
                    {" "}
                    {e.value ? new Date(e.value).toLocaleString() : "New User - Crawl Pending"}{" "}
                  </span>
                ),
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (rowInfo?.original?.my) ? color : textColor,
                      background: rowInfo?.original?.my ? background : "#b3e5fc",
                    },
                  };
                },
                width: 200,
              },
            ],
          },
          {
            Header: "TOTAL",
            fixed: "right",
            columns: [
              {
                show: ShowFlags,
                Header: "Red",
                accessor: "red_flag",
                Cell: (e) => { 
                  return <OverlayTrigger trigger="click" placement="left" overlay={
                      <Popover id="popover-basic">
                        <Popover.Header>
                          {e.original.name}
                        </Popover.Header>
                        <Popover.Body>
                        {Object.keys(e?.original?.red_flag_sites) &&
                              Object.keys(e?.original?.red_flag_sites).length >
                                0 &&
                              Object.keys(e?.original?.red_flag_sites).map(
                                (site) =>
                                  e?.original?.red_flag_sites[site] &&
                                  e?.original?.red_flag_sites[site].length >
                                    0 ? (
                                    <div>
                                      <h6>{site}</h6>
                                      <ul>
                                        {e?.original?.red_flag_sites[site]?.map(
                                          (criteria) => {
                                            return <li>{criteria}</li>;
                                          }
                                        )}
                                      </ul>
                                    </div>
                                  ) : null
                              )}
                        </Popover.Body>
                      </Popover>
                    }>
                          <span style={{ cursor: "pointer" }}>{e.value}</span>  
                      </OverlayTrigger>
                },
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (rowInfo?.original?.my) ? 'white' : 'white',
                      background: (rowInfo?.original?.red_flag == 0) ? "#66BB6A" : "#EF5350",
                    },
                  };
                },
                width: 50,
              },
              {
                Header: ()=>(<div><div>Overall Score</div><div style={{fontSize: '12px'}}>{formulas && formulaColumns && sinceretyScore &&`${columnCode?.sincerety_score}*${sinceretyScore}`+ makeFormula("", false, true)}</div></div>),
                accessor: "total_score",
                Cell: (e) => (
                  <span >
                    {" "}
                    {e.value}{" "}
                  </span>
                ),
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (rowInfo?.original?.my) ? 'white' : 'white',
                      background: rowInfo?.original?.my ? background : "#0F9ADC",
                    },
                  };
                },
                width: 180,
              },
              {
                Header: "Global Rank",
                accessor: "global_rank",
                Cell: (e) => (
                  
                  <span  title={
                    isDelta ?(e.value > 0) ? `Rank fell by ${e.value} places and Score decreased by ${e.original.total_score}`
                    : (e.value < 0) ? `Rank rose by ${-1 * e.value} places and Score increased by ${e.original.total_score}`
                    : null
                    : null }  >
                    <span style={{float : 'left'}}>{isDelta ? 
                      (e.value < 0) ? (<FaArrowUp style={{ alignItems: 'left' , color : 'green'}} />)
                      : (e.value > 0) ? (<FaArrowDown style={{ alignContent : 'left' ,color : 'red'}} />)
                      :  (e.value === 0) ? (<FaEquals style={{color : 'black'}} />) 
                      : null
                     : null}</span>
                    
                    <span style = {{textAlign : 'center', position : 'relative'}}>{" "}{e.value}{" "}</span>
                  </span>
                ),
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (rowInfo?.original?.my) ? 'white' : 'white',
                      background: rowInfo?.original?.my ? background : "#7ec381",
                    },
                  };
                },
                width: 100,
              },
              {
                Header: "Last Activity",
                accessor: "lastActiveTime",
                sortMethod: sortDate,
                Cell: (e) => (
                  <span >
                    {" "}
                    {e.value}{" "}
                  </span>
                ),
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: 'white',
                      background: rowInfo?.original?.my ? background : "#7ec381",
                    },
                  };
                },
              }
            ],
          },
        ]}
        // style={{
        //   height: "110vh" // This will force the table body to overflow and scroll, since there is not enough room
        // }}
        // style={{
        //   height: "110vh" ,// This will force the table body to overflow and scroll, since there is not enough room
        //   fontWeight: "bolder"
        // }}

        className=" -highlight text-dark h5"
      />
      </div>}
    </div>
  );
}

export default Main;
